<template>
    <div class="date-wrapper">
        <div v-if="label && !isMobile" class="label">{{ label }}</div>
        <div class="data-model">
            <div v-if="coins" class="coins">{{ coins }}</div>

      <div
        v-if="isMobile"
        class="mt-input"
        :class="{ disabled, active: active, invalid: !valid }"
      >
        <div
          v-if="label"
          class="label"
          :class="{ 'hold-place': !ymd && !active }"
        >
                    {{ label }}
                </div>

                <input
                    class="mt-input__value"
                    ref="ref_picker"
                    type="date"
                    :class="{ disabled }"
                    v-model="innerValue"
                    :disabled="disabled"
                    @focus="active = true"
                    @blur="active = false"
                    :min="minDate"
                    :max="maxDate"
                />
                <div class="calendar-icon" @click="pickerClickHandler"></div>
            </div>


      <template
          v-if="!isMobile"
      >
                <ModelSelect
                    class="day"
                    label="День"
                    item-text="value"
                    :items="days"
                    v-model="day"
                    :valid="valid"
                    :disabled="disableInputs"
                />
                <ModelSelect
                    class="month"
                    label="Месяц"
                    :items="months"
                    v-model="month"
                    :valid="valid"
                    :disabled="disableInputs"
                />

                <ModelString
                    v-if="yearInputType==='input'"
                    class="year"
                    type="number"
                    label="Год"
                    v-model="year"
                    :valid="valid"
                    maxlength="4"
                    :hidden-lenght-counter="hiddenLenghtCounter"
                    :input-filter="getYearInputValidator"
                    :disabled="disableInputs"
                />
                <ModelSelect
                    v-else
                    class="year"
                    label="Год"
                    item-text="value"
                    :items="years"
                    v-model="year"
                    :valid="valid"
                    :disabled="disableInputs"
                />
            </template>
        </div>

        <div class="error-message" v-if="showErrors && errorMessage">{{ errorMessage }}</div>
    </div>
</template>

<script>
import ModelSelect from "./ModelSelect";
import ModelString from "./ModelString";

import { mapGetters } from "vuex";
const parseYmd = ymd => {
    ymd = String(ymd);

    return {
        year: +ymd.slice(0, 4),
        month: +ymd.slice(4, 6),
        day: +ymd.slice(6, 8),
    };
};

const dayCount = (year, month) => {
    if (!month || !year) return 31;

    const isLeap = year && !(year % 4);

    return [31, isLeap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][
        month - 1
    ];
};

const getters = ["isMobile"];

export default {
    name: "ModelYMD",
    props: {
        ymd: Number,
        coins: Number,
        disableInputs: {
            type: Boolean,
            default: false,
        },
        disabled: Boolean,
        label: String,
        valid: {
            type: Boolean,
            default: true,
        },
        yearInputType: {
            type: String,
            default: 'input',
        },
        minYear: {
            type: Number,
            default: 1,
        },
        maxYear: {
            type: Number,
            default: 9999,
        },
        validator: {
            type: Function,
            default: null,
        },
        showErrors: {
            type: Boolean,
            default: true,
        },
        hiddenLenghtCounter: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ModelSelect,
        ModelString,
    },
    data() {
        const { year, month, day } = parseYmd(this.ymd);
        const isValid = day > 0 && day <= dayCount(year, month);

        return {
            year: isValid ? year : '',
            month: isValid ? month : '',
            day: isValid ? day : '',

            active: false,
            months: [
                { text: "Январь", value: 1 },
                { text: "Февраль", value: 2 },
                { text: "Март", value: 3 },
                { text: "Апрель", value: 4 },
                { text: "Май", value: 5 },
                { text: "Июнь", value: 6 },
                { text: "Июль", value: 7 },
                { text: "Август", value: 8 },
                { text: "Сентябрь", value: 9 },
                { text: "Октябрь", value: 10 },
                { text: "Ноябрь", value: 11 },
                { text: "Декабрь", value: 12 },
            ],
        };
    },
    computed: {
        ...mapGetters(getters),
        days() {
            const count = dayCount(this.year, this.month);
            const arr = [];

            if (count) for (let i = 0; i < count; i++) arr.push({ value: i + 1 });

            return arr;
        },
        minDate() {
            return this.minYear
                ? (new Date(this.minYear, 0, 1))
                    .toISOString()
                    .slice(0, 10)
                : null;
        },
        maxDate() {
            return this.maxYear
                ? (new Date(this.maxYear, 11, 31))
                    .toISOString()
                    .slice(0, 10)
                : null;
        },
        innerValue: {
            set(v) {
                let [year, month, day] = v.split("-");
                console.log(v);
                this.year = year;
                this.month = month;
                this.day = day;
            },
            get() {
                if (!this.day || !this.month || !this.year) return null;
                const isValid =
          this.day > 0 && this.day <= dayCount(this.year, this.month);

                const month = String(this.month).padStart(2, "0");
                const day = String(this.day).padStart(2, "0");

                return isValid ? `${this.year}-${month}-${day}` : null;
            },
        },
        years() {
            return new Array(this.maxYear-this.minYear+1)
                .fill(this.minYear)
                .map((v, i) => ({ value: v + i }))
                .reverse();
        },
        getYearInputValidator() {
            return (value) => {
                let maxValue = parseInt(value.padEnd(4, '9'));
                let minValue = parseInt(value.padEnd(4, '0'));

                return !value || (isFinite(value) && (value ^ 0))
                    && (maxValue >= this.minYear)
                    && (minValue <= this.maxYear);
            };
        },
        errorMessage() {
            if (!this.validator) {
                return null;
            }

            return this.validator(new Date(this.year, this.month-1, this.day));
        },
    },
    methods: {
        createYmd() {
            if (!this.day || !this.month || !this.year) return null;
            const isValid =
        this.day > 0 && this.day <= dayCount(this.year, this.month);

            const month = String(this.month).padStart(2, "0");
            const day = String(this.day).padStart(2, "0");

            return isValid ? +`${this.year}${month}${day}` : null;
        },

        pickerClickHandler() {
            const picker = this.$refs['ref_picker'];
            if (picker) {
                picker.focus();
                picker.click();
            }
        },
    },
    model: {
        prop: "ymd",
        event: "change",
    },
    watch: {
        ymd() {
            const { year, month, day } = parseYmd(this.ymd);
            const isValid = day > 0 && day <= dayCount(year, month);
            if (isValid) {
                this.year = year;
                this.month = month;
                this.day = day;
            }
        },

        day() {
            const ymd = this.createYmd();
            if (ymd) this.$emit("change", ymd);
        },

        month() {
            this.day = Math.min(dayCount(this.year, this.month), this.day);

            const ymd = this.createYmd();
            if (ymd) this.$emit("change", ymd);

            // if (!this.days.includes(this.day)) this.day = null;
        },

        year() {
            this.day = Math.min(dayCount(this.year, this.month), this.day);

            const ymd = this.createYmd();
            if (ymd) this.$emit("change", ymd);
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/rem";
@import "../../../styles/mrem";
@import "../../../styles/mt";

.date-wrapper {
    margin-top: rem(20);
}

.data-model {
    display: flex;
    user-select: none;
}

.day {
    margin-right: rem(4);
    flex: 1 1 auto;
    width: auto;
}

.month {
    margin-left: rem(4);
    margin-right: rem(4);
    flex: 2 1 auto;
}
.year {
    margin-left: rem(4);
    flex: 1 1 auto;
    width: auto;
}

@media (min-width: $vm) {
    .label {
        font-size: rem(16);
        position: static;
        width: 100%;
    }
}

@import "../../../styles/variables";
@media (max-width: $vm) {
    .mt-input__value {
        background-color: #ffffff;
    }
    .data-model {
    }
    .day {
    }

    .month {
    }
    .year {
    }

    .label {
        top: mrem(-7);
        left: mrem(8);
        padding-left: mrem(8);
        padding-right: mrem(8);
        font-size: mrem(12);
        line-height: mrem(16);
        color: #98a0a9;
        position: absolute;
        background: white;
        font-weight: 600;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        transition: 0.1s;
        pointer-events: none;
    }

    .label.hold-place {
        color: #98a0a9;
        font-style: normal;
        font-weight: normal;
        top: mrem(12);
        font-size: mrem(16);
        line-height: mrem(24);
        width: 80%;
        display: flex;
        justify-content: flex-start !important;
        align-items: center;
        background-color: #fff;
    }

    .label.hold-place.invalid {
        color: red;
    }

    .active {
        border-style: solid;
    border-color: #4663AB;
        border-width: mrem(2);

        .label {
      color: #4663AB;
            top: mrem(-8);
            left: mrem(7);
        }
    }

    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .calendar-icon {
        position: absolute;
        z-index: 1;
        right: mrem(19);
        width: mrem(20);
        height: mrem(20);
    background: #FFFFFF url("../../../assets/images/icons/calendar-ico.svg") no-repeat center/contain;
    }
}


.error-message {
    font-style: normal;
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(24);
    color: #EF627D;
    @media (max-width: $vm) {
        font-size: mrem(16);
        line-height: mrem(24);
    }
}
</style>
